import React, { useState } from 'react';
import { Menu, X, Bell, Search, LogOut } from 'lucide-react';
import { cn } from '../../utils/cn';
import { useAuthStore } from '../../stores/authStore';
interface HeaderProps {
  onToggleSidebar: () => void;
  isSidebarOpen: boolean;
}
export function Header({
  onToggleSidebar,
  isSidebarOpen
}: HeaderProps) {
  const logout = useAuthStore(state => state.logout);
  const user = useAuthStore(state => state.user);
  return <header className="h-16 bg-white border-b border-slate-200 fixed top-0 right-0 left-0 z-40 flex items-center justify-between px-4 sm:px-6" data-id="element-145">
      <div className="flex items-center gap-4" data-id="element-146">
        <button onClick={onToggleSidebar} className="p-2 rounded-md hover:bg-slate-100 text-slate-500 lg:hidden" data-id="element-147">
          {isSidebarOpen ? <X className="w-5 h-5" data-id="element-148" /> : <Menu className="w-5 h-5" data-id="element-149" />}
        </button>
      </div>

      <div className="flex items-center gap-2 sm:gap-4" data-id="element-150">
        <button className="p-2 rounded-full hover:bg-slate-100 text-slate-500 relative" data-id="element-151">
          <Bell className="w-5 h-5" data-id="element-152" />
          <span className="absolute top-2 right-2 w-2 h-2 bg-red-500 rounded-full border-2 border-white" data-id="element-153"></span>
        </button>

        <div className="h-8 w-px bg-slate-200 mx-1" data-id="element-154"></div>

        <div className="flex items-center gap-3" data-id="element-155">
          <div className="flex items-center gap-2 p-1 rounded-lg" data-id="element-156">
            <div className="w-8 h-8 rounded-full bg-primary-600 flex items-center justify-center text-white text-xs font-bold" data-id="element-157">
              {user?.name?.split(' ').map(n => n[0]).join('') || 'AD'}
            </div>
            <div className="hidden md:block text-left" data-id="element-158">
              <p className="text-sm font-medium text-slate-900 leading-none" data-id="element-159">
                {user?.name || 'Admin User'}
              </p>
              <p className="text-xs text-slate-500 mt-1 capitalize" data-id="element-160">
                {user?.role || 'Administrator'}
              </p>
            </div>
          </div>

          <button onClick={() => logout()} className="p-2 rounded-full hover:bg-red-50 text-slate-400 hover:text-red-600 transition-colors" title="Logout" data-id="element-161">
            <LogOut className="w-5 h-5" data-id="element-162" />
          </button>
        </div>
      </div>
    </header>;
}